import {WidgetType} from '@codemirror/view'

import styles from './image.module.css'

export class ImageWidget extends WidgetType {
  #src: string
  #alt: string
  #title?: string

  constructor(src: string, alt: string, title?: string) {
    super()
    this.#src = src
    this.#alt = alt
    this.#title = title
  }

  toDOM() {
    const img = document.createElement('img')
    img.src = this.#src

    // Always use the provided alt text, even if empty
    // This maintains accessibility while avoiding the presentation role
    // that could hide the image from screen readers entirely
    img.alt = this.#alt

    if (this.#title) {
      img.title = this.#title
    }

    img.className = styles.imageWidget || ''

    return img
  }

  override eq(widget: ImageWidget) {
    return widget.#src === this.#src && widget.#alt === this.#alt && widget.#title === this.#title
  }

  override ignoreEvent() {
    return false
  }
}
